// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventory-page .compact-header-actions .compact-primary {
  padding-inline: 10px;
}
.inventory-page .inventory-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-bottom: 10px;
}
.inventory-page .inventory-summary > div {
  border: 1px solid #e1e6ef;
  border-radius: 11px;
  background: white;
  padding: 10px;
  display: grid;
  gap: 5px;
  min-width: 0;
}
.inventory-page .inventory-summary span {
  font-size: 10px;
  color: #78849a;
  line-height: 1.4;
}
.inventory-page .inventory-summary b {
  font-size: 19px;
  font-variant-numeric: tabular-nums;
}
.inventory-page .inventory-search {
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
}
.inventory-page .inventory-search .compact-search {
  flex: 1 1;
  margin-bottom: 0;
}
.inventory-page .inventory-search .active {
  background: #fff1f4;
  border-color: #f4d6dc;
  color: #e72f44;
}
.inventory-page .inventory-materials {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 10px;
}
.inventory-page .inventory-material {
  margin-bottom: 0;
}
.inventory-page .inventory-material-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.inventory-page .inventory-material-heading > div {
  flex: 1 1;
  min-width: 0;
}
.inventory-page .inventory-material-heading h2 {
  margin: 0 0 4px;
  font-size: 14px;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.inventory-page .inventory-material-heading small {
  color: #78849a;
  font-size: 10px;
  overflow-wrap: anywhere;
}
.inventory-page .inventory-material-heading .compact-icon-button {
  border: none;
}
.inventory-page .inventory-material-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 10px 0;
}
.inventory-page .inventory-material-metrics > div {
  min-width: 0;
  display: grid;
  gap: 5px;
}
.inventory-page .inventory-material-metrics span {
  color: #78849a;
  font-size: 10px;
}
.inventory-page .inventory-material-metrics b {
  font-size: 15px;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.inventory-page .inventory-risk {
  color: #b32943;
}
.inventory-page .inventory-material .inventory-risk-note {
  margin: 0 0 8px;
  font-size: 11px;
  color: #a77736;
}
.inventory-page .inventory-movement-button {
  width: 100%;
}
.inventory-page .inventory-material-details {
  margin-top: 8px;
  border-top: 1px solid #edf0f5;
}
.inventory-page .inventory-material-details > summary {
  font-size: 11px;
  color: #78849a;
}
.inventory-page .inventory-material-details p {
  overflow-wrap: anywhere;
}
.inventory-page .inventory-marking {
  margin-top: 8px;
  border-top: 1px solid #edf0f5;
}
.inventory-page .inventory-marking > summary {
  font-size: 12px;
  color: #78849a;
}
.inventory-page .inventory-marking .compact-checkbox {
  gap: 10px;
  flex-direction: row;
}
.inventory-page .inventory-suppliers {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}
.inventory-page .inventory-suppliers > button {
  max-width: 100%;
  overflow-wrap: anywhere;
  font-size: 12px;
}
.inventory-page .inventory-order-form {
  padding: 12px;
  border-radius: 12px;
  background: #f7f9fc;
  border: 1px solid #e5e9f1;
}
.inventory-page .inventory-order-form h3 {
  overflow-wrap: anywhere;
}
.inventory-page .inventory-order, .inventory-page .inventory-history-row {
  border-top: 1px solid #edf0f5;
}
.inventory-page .inventory-order summary, .inventory-page .inventory-history-row summary {
  min-height: 68px;
}
.inventory-page .inventory-order summary > span, .inventory-page .inventory-history-row summary > span {
  flex: 1 1;
  min-width: 0;
  display: grid;
  gap: 5px;
}
.inventory-page .inventory-order summary strong, .inventory-page .inventory-history-row summary strong {
  font-size: 13px;
  overflow-wrap: anywhere;
}
.inventory-page .inventory-order summary small, .inventory-page .inventory-history-row summary small {
  color: #78849a;
  font-size: 10px;
  line-height: 1.5;
}
.inventory-page .inventory-order summary > b, .inventory-page .inventory-history-row summary > b {
  font-size: 14px;
  text-align: right;
  max-width: 40%;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.inventory-page .inventory-order p, .inventory-page .inventory-history-row p {
  overflow-wrap: anywhere;
}
.inventory-page .inventory-order .compact-actions {
  gap: 6px;
}
.inventory-page .inventory-order .compact-actions button {
  font-size: 12px;
}
.inventory-page .inventory-order-line {
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-top: 1px solid #edf0f5;
  font-size: 12px;
}
.inventory-page .inventory-order-line span {
  min-width: 0;
  overflow-wrap: anywhere;
}
.inventory-page .inventory-order-line small {
  display: block;
  margin-top: 4px;
  font-size: 10px;
}
.inventory-page .inventory-order-line b {
  max-width: 40%;
  overflow-wrap: anywhere;
  text-align: right;
}
.inventory-page .inventory-companies {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 12px 0;
}
.inventory-page .inventory-companies label {
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid #e1e6ef;
  background: #f8fafd;
  box-sizing: border-box;
}
.inventory-page .inventory-companies span {
  overflow-wrap: anywhere;
  font-size: 12px;
  line-height: 1.5;
}
.inventory-page .inventory-consolidate-button {
  width: 100%;
  margin-block: 4px 8px;
}
.inventory-page .inventory-purchase-line {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-top: 1px solid #edf0f5;
}
.inventory-page .inventory-purchase-line > div {
  flex: 1 1;
  min-width: 0;
  display: grid;
  gap: 4px;
}
.inventory-page .inventory-purchase-line strong {
  font-size: 13px;
  overflow-wrap: anywhere;
}
.inventory-page .inventory-purchase-line small {
  color: #78849a;
  font-size: 10px;
  line-height: 1.5;
}
.inventory-page .inventory-purchase-line > b {
  max-width: 35%;
  text-align: right;
  font-size: 14px;
  overflow-wrap: anywhere;
}
.inventory-page .inventory-method p {
  color: #78849a;
}
.inventory-page .inventory-terminal-link {
  justify-self: start;
}
@media (max-width: 650px) {
  .inventory-page .inventory-materials, .inventory-page .inventory-companies {
    grid-template-columns: minmax(0, 1fr);
  }
  .inventory-page .inventory-summary > div {
    padding: 9px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/InventoryPage/inventory.scss"],"names":[],"mappings":"AACE;EAA2C,oBAAA;AAC7C;AAAE;EAAqB,aAAA;EAAe,gDAAA;EAAkD,QAAA;EAAU,mBAAA;AAMlG;AALI;EAAQ,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,aAAA;EAAe,aAAA;EAAe,QAAA;EAAU,YAAA;AAcvH;AAduI;EAAO,eAAA;EAAiB,cAAA;EAAgB,gBAAA;AAmB/K;AAnBmM;EAAI,eAAA;EAAiB,kCAAA;AAuBxN;AArBE;EAAoB,aAAA;EAAe,QAAA;EAAU,mBAAA;AA0B/C;AA1BoE;EAAkB,SAAA;EAAS,gBAAA;AA8B/F;AA9BmH;EAAU,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;AAmCzK;AAlCE;EAAuB,aAAA;EAAe,gDAAA;EAAkD,SAAA;EAAW,mBAAA;AAwCrG;AAvCE;EAAsB,gBAAA;AA0CxB;AAzCE;EAA8B,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,QAAA;AA+CpG;AA/C8G;EAAQ,SAAA;EAAS,YAAA;AAmD/H;AAnD+I;EAAK,eAAA;EAAiB,eAAA;EAAiB,uBAAA;EAAyB,oBAAA;EAAsB,qBAAA;EAAuB,4BAAA;EAA8B,gBAAA;AA4D1R;AA5D8S;EAAQ,cAAA;EAAgB,eAAA;EAAiB,uBAAA;AAiEvV;AAjEkX;EAAuB,YAAA;AAoEzY;AAnEE;EAA8B,aAAA;EAAe,gDAAA;EAAkD,QAAA;EAAU,cAAA;AAyE3G;AAxEI;EAAQ,YAAA;EAAc,aAAA;EAAe,QAAA;AA6EzC;AA7EqD;EAAO,cAAA;EAAgB,eAAA;AAiF5E;AAjF+F;EAAI,eAAA;EAAiB,kCAAA;EAAoC,uBAAA;AAsFxJ;AApFE;EAAkB,cAAA;AAuFpB;AAtFE;EAA2C,eAAA;EAAiB,eAAA;EAAiB,cAAA;AA2F/E;AA1FE;EAA6B,WAAA;AA6F/B;AA5FE;EAA8B,eAAA;EAAiB,6BAAA;AAgGjD;AAhGgF;EAAY,eAAA;EAAiB,cAAA;AAoG7G;AApG+H;EAAI,uBAAA;AAuGnI;AAtGE;EAAqB,eAAA;EAAiB,6BAAA;AA0GxC;AA1GuE;EAAY,eAAA;EAAiB,cAAA;AA8GpG;AA9GsH;EAAoB,SAAA;EAAW,mBAAA;AAkHrJ;AAjHE;EAAuB,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,mBAAA;AAuHnE;AAvHwF;EAAW,eAAA;EAAiB,uBAAA;EAAyB,eAAA;AA4H7I;AA3HE;EAAwB,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,yBAAA;AAiInF;AAjI8G;EAAK,uBAAA;AAoInH;AAnIE;EAA2C,6BAAA;AAsI7C;AArII;EAAU,gBAAA;AAwId;AAxIgC;EAAS,SAAA;EAAS,YAAA;EAAc,aAAA;EAAe,QAAA;AA8I/E;AA9I2F;EAAS,eAAA;EAAiB,uBAAA;AAkJrH;AAlJgJ;EAAQ,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAuJzL;AAvJ6M;EAAM,eAAA;EAAiB,iBAAA;EAAmB,cAAA;EAAgB,kCAAA;EAAoC,uBAAA;AA8J3S;AA7JI;EAAI,uBAAA;AAgKR;AA9JE;EAAoC,QAAA;AAiKtC;AAjKgD;EAAS,eAAA;AAoKzD;AAnKE;EAAwB,aAAA;EAAe,QAAA;EAAU,8BAAA;EAAgC,mBAAA;EAAqB,eAAA;EAAiB,6BAAA;EAA+B,eAAA;AA4KxJ;AA3KI;EAAO,YAAA;EAAc,uBAAA;AA+KzB;AA/KoD;EAAQ,cAAA;EAAgB,eAAA;EAAiB,eAAA;AAoL7F;AApLgH;EAAI,cAAA;EAAgB,uBAAA;EAAyB,iBAAA;AAyL7J;AAvLE;EAAuB,aAAA;EAAe,gDAAA;EAAkD,QAAA;EAAU,cAAA;AA6LpG;AA5LI;EAAQ,iBAAA;EAAmB,mBAAA;EAAqB,yBAAA;EAA2B,mBAAA;EAAqB,sBAAA;AAmMpG;AAnM8H;EAAO,uBAAA;EAAyB,eAAA;EAAiB,gBAAA;AAwM/K;AAtME;EAAgC,WAAA;EAAa,qBAAA;AA0M/C;AAzME;EAA2B,aAAA;EAAe,SAAA;EAAW,8BAAA;EAAgC,mBAAA;EAAqB,eAAA;EAAiB,6BAAA;AAiN7H;AAjN4J;EAAQ,SAAA;EAAS,YAAA;EAAc,aAAA;EAAe,QAAA;AAuN1M;AAvNsN;EAAS,eAAA;EAAiB,uBAAA;AA2NhP;AA3N2Q;EAAQ,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAgOpT;AAhOwU;EAAM,cAAA;EAAgB,iBAAA;EAAmB,eAAA;EAAiB,uBAAA;AAsOlY;AArOE;EAAsB,cAAA;AAwOxB;AAvOE;EAA2B,mBAAA;AA0O7B;AAzOE;EAA4B;IAA6C,qCAAA;EA6OzE;EA7OkH;IAA2B,YAAA;EAgP7I;AACF","sourcesContent":[".inventory-page {\n  .compact-header-actions .compact-primary { padding-inline: 10px; }\n  .inventory-summary { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 6px; margin-bottom: 10px;\n    > div { border: 1px solid #e1e6ef; border-radius: 11px; background: white; padding: 10px; display: grid; gap: 5px; min-width: 0; } span { font-size: 10px; color: #78849a; line-height: 1.4; } b { font-size: 19px; font-variant-numeric: tabular-nums; }\n  }\n  .inventory-search { display: flex; gap: 6px; margin-bottom: 10px; .compact-search { flex: 1; margin-bottom: 0; } .active { background: #fff1f4; border-color: #f4d6dc; color: #e72f44; } }\n  .inventory-materials { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin-bottom: 10px; }\n  .inventory-material { margin-bottom: 0; }\n  .inventory-material-heading { display: flex; justify-content: space-between; align-items: center; gap: 8px; > div { flex: 1; min-width: 0; } h2 { margin: 0 0 4px; font-size: 14px; overflow-wrap: anywhere; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; } small { color: #78849a; font-size: 10px; overflow-wrap: anywhere; } .compact-icon-button { border: none; } }\n  .inventory-material-metrics { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; margin: 10px 0;\n    > div { min-width: 0; display: grid; gap: 5px; } span { color: #78849a; font-size: 10px; } b { font-size: 15px; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }\n  }\n  .inventory-risk { color: #b32943; }\n  .inventory-material .inventory-risk-note { margin: 0 0 8px; font-size: 11px; color: #a77736; }\n  .inventory-movement-button { width: 100%; }\n  .inventory-material-details { margin-top: 8px; border-top: 1px solid #edf0f5; > summary { font-size: 11px; color: #78849a; } p { overflow-wrap: anywhere; } }\n  .inventory-marking { margin-top: 8px; border-top: 1px solid #edf0f5; > summary { font-size: 12px; color: #78849a; } .compact-checkbox { gap: 10px; flex-direction: row; } }\n  .inventory-suppliers { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 10px; > button { max-width: 100%; overflow-wrap: anywhere; font-size: 12px; } }\n  .inventory-order-form { padding: 12px; border-radius: 12px; background: #f7f9fc; border: 1px solid #e5e9f1; h3 { overflow-wrap: anywhere; } }\n  .inventory-order, .inventory-history-row { border-top: 1px solid #edf0f5;\n    summary { min-height: 68px; > span { flex: 1; min-width: 0; display: grid; gap: 5px; } strong { font-size: 13px; overflow-wrap: anywhere; } small { color: #78849a; font-size: 10px; line-height: 1.5; } > b { font-size: 14px; text-align: right; max-width: 40%; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; } }\n    p { overflow-wrap: anywhere; }\n  }\n  .inventory-order .compact-actions { gap: 6px; button { font-size: 12px; } }\n  .inventory-order-line { display: flex; gap: 8px; justify-content: space-between; align-items: center; padding: 10px 0; border-top: 1px solid #edf0f5; font-size: 12px;\n    span { min-width: 0; overflow-wrap: anywhere; } small { display: block; margin-top: 4px; font-size: 10px; } b { max-width: 40%; overflow-wrap: anywhere; text-align: right; }\n  }\n  .inventory-companies { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; margin: 12px 0;\n    label { padding: 8px 10px; border-radius: 10px; border: 1px solid #e1e6ef; background: #f8fafd; box-sizing: border-box; } span { overflow-wrap: anywhere; font-size: 12px; line-height: 1.5; }\n  }\n  .inventory-consolidate-button { width: 100%; margin-block: 4px 8px; }\n  .inventory-purchase-line { display: flex; gap: 10px; justify-content: space-between; align-items: center; padding: 12px 0; border-top: 1px solid #edf0f5; > div { flex: 1; min-width: 0; display: grid; gap: 4px; } strong { font-size: 13px; overflow-wrap: anywhere; } small { color: #78849a; font-size: 10px; line-height: 1.5; } > b { max-width: 35%; text-align: right; font-size: 14px; overflow-wrap: anywhere; } }\n  .inventory-method p { color: #78849a; }\n  .inventory-terminal-link { justify-self: start; }\n  @media (max-width: 650px) { .inventory-materials, .inventory-companies { grid-template-columns: minmax(0, 1fr); } .inventory-summary > div { padding: 9px; } }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
